import {Downgraded, useState} from "@hookstate/core";
import {Button, Form, FormCheck, Table} from "react-bootstrap";
import * as XLSX from "xlsx";

import "./InvoiceParser.scss";
import {getJobIdByNumber, pushInvoices} from "../../Services/ApiService";


function InvoiceParser() {
    const uploadedFile = useState(null);
    const uploadedFileName = useState('');
    const message = useState("");
    const ignoreFileSize = useState(false);

    const invoicesReady = useState(false);


    const invoices = useState([{
        jobId: undefined,
        "No.": -1,
        "Total before sales tax": 0,
        "Sales tax": 0,
        "Shipping": 0,
        "Postage": 0,
        "Amount": 0
    }]);
    const myHeaders = ["Submit", "Number", "Customer", "Memo", "Net", "Tax", "Shipping", "Postage", "Total"];
    const checkedInvoices = useState([]);
    const modifiedInvoices = useState([]);

    function onFileChange(e) {
        checkedInvoices.set([]);
        modifiedInvoices.set([]);

        let file = e.target.files[0];
        uploadedFile.set(file);
        uploadedFileName.set(file.name);

        let maxFileSize = 16 * 1024; // convert to kb
        if (file.size > maxFileSize && !ignoreFileSize.get()) {
            message.set("File size is large, use the checkbox if needed.");
        } else {
            parseInvoices(file);
        }
    }

    function parseInvoices(file) {
        message.set("Loading...");

        if (file.name.match(/\.xls/) !== null) {
            let tempInvoices = [];
            let reader = new FileReader();

            reader.readAsArrayBuffer(file);

            reader.onload = function (e) {
                let workbook = XLSX.read(e.target.result);

                tempInvoices = XLSX.utils.sheet_to_json(workbook.Sheets.Worksheet, {range: 1})
                    .sort((a, b) => b["No."] - a["No."])
                    .filter(invoice => invoice.Type === "Invoice");


                tempInvoices.forEach(invoice => {
                    getJobIdByNumber(invoice["No."], retrievedId => {
                        if (retrievedId[0].id !== undefined) {
                            invoice.jobId = retrievedId[0].id;
                        } else {
                            invoice.jobId = 0;
                        }
                    });

                    invoice.Shipping = 0;
                    invoice.Postage = 0;
                });

                console.log(tempInvoices);

                invoices.set(tempInvoices);
                changeSelectionAll(1);

                invoicesReady.set(true);
            };
        } else {
            message.set("File must be .xls");
        }

        message.set("");
    }

    function onCheckChange(e, _invoice) {
        if (e.target.checked) {
            checkedInvoices.set([...checkedInvoices.get(), _invoice["No."]]);
        } else {
            checkedInvoices.set(checkedInvoices.get().filter(invoice => {
                return invoice !== _invoice["No."];
            }));
        }
    }

    function onFormSubmit() {
        let submittedInvoices = invoices.attach(Downgraded).get().filter(invoice => {
            return checkedInvoices.get().includes(invoice["No."]);
        })

        pushInvoices(submittedInvoices, res => {
            modifiedInvoices.set(res);
        });
    }

    function changeSelectionAll(option) {
        if (option === 0) {
            checkedInvoices.set([]);
        } else if (option === 1) {
            invoices.get().forEach(invoice => {
                if (!checkedInvoices.get().includes(invoice["No."])) {
                    checkedInvoices.set([...checkedInvoices.get(), invoice["No."]]);
                }
            })
        }
    }

    function invoiceTable() {
        if (invoicesReady.get()) {
            return <div>
                <Table>
                    <thead>
                    <tr>
                        {myHeaders.map((header, idx) => {
                            return <td key={idx}>{header}</td>
                        })}
                    </tr>
                    </thead>
                    <tbody>
                    {invoices.get().map((invoice, idx) => {
                        // noinspection JSUnresolvedReference,JSCheckFunctionSignatures
                        return <tr key={idx}>
                            <td id={'checkBox'}>
                                <FormCheck checked={checkedInvoices.get().includes(invoice["No."])}
                                           onChange={e => {
                                               onCheckChange(e, invoice)
                                           }}
                                />
                            </td>
                            <td className={`modified-${modifiedInvoices.get().includes(invoice["No."])}`}>
                                {invoice.jobId !== undefined &&
                                    <a href={`/job/${invoice.jobId}`} target={"_blank"} rel={"noreferrer"}>
                                        {invoice["No."]}
                                    </a>}
                                {invoice.jobId === undefined && `${invoice["No."]}`}
                            </td>
                            <td>{invoice["Customer"]}{invoice["Client"]}</td>
                            <td>{invoice["Memo"]}</td>
                            <td>
                                <Form.Control id={`net-${idx}`}
                                              type={'number'}
                                              value={(invoices[idx].get()["Total before sales tax"])}
                                              onChange={e => invoices[idx]["Total before sales tax"].set(e.target.value)}
                                />
                            </td>
                            <td>
                                <Form.Control id={`tax-${idx}`}
                                              type={'number'}
                                              value={(invoices[idx].get()["Sales tax"])}
                                              onChange={e => invoices[idx]["Sales tax"].set(e.target.value)}
                                />
                            </td>
                            <td>
                                <Form.Control id={`shipping-${idx}`}
                                              type={'number'}
                                              value={(invoices[idx].get().Shipping)}
                                              onChange={e => invoices[idx].Shipping.set(e.target.value)}
                                />
                            </td>
                            <td>
                                <Form.Control id={`postage-${idx}`}
                                              type={'number'}
                                              value={(invoices[idx].get().Postage)}
                                              onChange={e => invoices[idx].Postage.set(e.target.value)}
                                />
                            </td>
                            <td>
                                <Form.Control id={`total-${idx}`}
                                              type={'number'}
                                              value={(invoices[idx].get().Amount)}
                                              onChange={e => invoices[idx].Amount.set(e.target.value)}
                                />
                            </td>
                        </tr>
                    })}
                    </tbody>
                </Table>
                <p>{checkedInvoices.get().length} of {invoices.get().length} invoices selected</p>
                <div id={'buttons'}>
                    <div id={'left'}>
                        <Button onClick={_ => changeSelectionAll(0)}>Select None</Button>
                        <Button onClick={_ => changeSelectionAll(1)}>Select All</Button>
                    </div>
                    <Button onClick={_ => onFormSubmit()}>Submit</Button>
                </div>
            </div>
        }
    }

    return <div id={'invoiceParser'}>
        <div id={'fileUploadForm'}>
            <Form.Control type={"file"} accept={'.xls'} id={'fileUpload'}
                          value={uploadedFileName.get() === null ? "" : uploadedFileName.get().name}
                          onChange={e => onFileChange(e)}
            />
            <FormCheck checked={ignoreFileSize.get()} id={'ignoreFileSizeCheck'}
                       onChange={e => {
                           ignoreFileSize.set(e.target.checked);
                       }}
                       label={"Ignore file size"}
            />
        </div>

        {invoiceTable()}

        <br/>
        <h5>{message.get()}</h5>
    </div>
}

export default InvoiceParser;